const _env = process.env;

export const NODE_ENV = _env.NODE_ENV;

export const BASE_URL = _env.BASE_URL;

//Configuraciones para authenticacion (aun no en uso)
export const AUTH = {
  AUTHORITY: _env.VUE_APP_URL_AUTH,
  CLIENT_ID: _env.VUE_APP_CLIENT_ID,
  POST_LOGOUT_REDIRECT_URI: "http://localhost:8080",
  REDIRECT_URI: _env.VUE_APP_REDIRECT_URI,
  RESPONSE_TYPE: _env.VUE_APP_RESPONSE_TYPE,
  SCOPE: _env.VUE_APP_SCOPE,
  SILENT_REDIRECT_URI: _env.VUE_APP_SILENT_REDIRECT
};

export const API = {
  BASE_URL: _env.VUE_APP_URL_API,
  TIMEOUT: 220000
};

export const API_PROV = {
  BASE_URL: _env.VUE_APP_URL_PROV,
  TIMEOUT: 220000
};

export const ACR_URL_LOGOUT = _env.VUE_APP_ACR_URL_LOGOUT;
export const ACR_VALUES = _env.VUE_APP_ACR_VALUES;
export const DEFAULT_PAGE_SIZE = _env.VUE_APP_DEFAULT_PAGE_SIZE;
export const SESSION_TIMEOUT = _env.VUE_APP_SESSION_TIMEOUT;
export const VUE_APP_RECAPTCHA_SITE_KEY = _env.VUE_APP_RECAPTCHA_SITE_KEY;
export const DASHBOARD_URL = _env.VUE_APP_DASHBOARD_URL;
export const SECURITY_URL = _env.VUE_APP_SECURITY_URL;
export const USER_MENU_APP_SESSION_KEY = `user-menu-${_env.VUE_APP_CLIENT_ID}`;
export const MIPE_PUBLIC_PORTAL_URL = _env.VUE_APP_MIPE_PUBLIC_PORTAL_URL;
export const DEPR_DIGITAL_SIGNATURE_URL = _env.VUE_APP_DEPR_DIGITAL_SIGNATURE_URL;
